import ContentCard from "./ContentCard"

export default function OneBook({ data }) {
  return <ContentCard data={data} type="Book" viewer="view-book" />
}
